import './App.css';
import Home from './pages/Home';
// import Video from './pages/Video';
import Game from './pages/Game';
import { Route, Routes } from 'react-router-dom';
import GameHome from './pages/GameHome';
import VideoPlayer from './pages/VideoPlayer';
import Movies from './pages/Movies';
import Spiritual from './pages/Spiritual';
import News from './pages/News'
import ReactGA from 'react-ga4'

function App() {
  ReactGA.initialize("G-XCPJ5J044Y");
  
  return (
    <div className='w-full h-screen mx-auto my-auto flex justify-center items-center'>
      <div className='relative w-full h-full border-2 border-black overflow-hidden flex flex-row justify-between items-center my-auto'>
        <Routes className="">
          <Route path='/' element={<Home/>}/>
          <Route path='youtubeVideo/video/:id' element={<VideoPlayer/>}/>
          <Route path='gameHome' element={<GameHome/>}/>
          <Route path='gameHome/game/:id' element={<Game/>}/>
          <Route path='movies' element={<Movies/>}/>
          <Route path='spiritual' element={<Spiritual/>}/>
          <Route path='news' element={<News/>}/>
        </Routes>
      </div>
    </div>
  );
}

export default App;
